type TokenSetupData = {
    token?: string | null;
};

type OzonSetupData = {
    api_key?: string | null;
    is_oauth_authorized?: boolean | null;
};

type YmlSetupData = {
    url?: string | null;
};

/**
 * Проверяет, подключён ли setup-источник по ответу GET setup.
 * Общая логика для меню смены источника, сортировки Datasources и marketplace connection.
 *
 * @kind helper
 */
export const isIntegrationSourceConnected = {
    wildberries: (data?: TokenSetupData | null) => Boolean(data?.token),
    yandex_market: (data?: TokenSetupData | null) => Boolean(data?.token),
    moysklad: (data?: TokenSetupData | null) => Boolean(data?.token),
    // TODO SS-7239 Удалить поддержку api_key после перехода всех партнёров на OAuth.
    ozon: (data?: OzonSetupData | null) => Boolean(data?.api_key || data?.is_oauth_authorized),
    yml: (data?: YmlSetupData | null) => Boolean(data?.url),
} as const;
